export { default as AddressRenderer } from './AddressRenderer.vue';
export { default as ButtonRenderer } from './ButtonRenderer.vue';
export { default as DataProviderRenderer } from './DataProviderRenderer.vue';
export { default as DataProviderSelectRenderer } from './DataProviderSelectRenderer.vue';
export { default as FileRenderer } from './FileRenderer.vue';
export { default as OneOfImageGroupControlRenderer } from './OneOfImageGroupControlRenderer.vue';
export { default as StripeCardRenderer } from './StripeCardRenderer.vue';
export { default as TemplateLabelRenderer } from './TemplateLabelRenderer.vue';
export { default as TemplateLayoutRenderer } from './TemplateLayoutRenderer.vue';
export { default as TemplateRenderer } from './TemplateRenderer.vue';
export { default as SlotRenderer } from './SlotRenderer.vue';
export { default as AgGridRenderer } from './AgGridRenderer.vue';
export { default as ArrayItem } from './ArrayItem.vue';
export { default as SignaturePadRenderer } from './SignaturePadRenderer.vue';
export { default as MonacoRenderer } from './MonacoRenderer.vue';

import { entry as addressRendererEntry } from './AddressRenderer.vue';
import { entry as buttonRendererEntry } from './ButtonRenderer.vue';
import { entry as dataProviderRendererEntry } from './DataProviderRenderer.vue';
import { entry as dataProviderSelectRendererEntry } from './DataProviderSelectRenderer.vue';
import { entry as fileRendererEntry } from './FileRenderer.vue';
import { entry as oneOfImageGroupControlRendererEntry } from './OneOfImageGroupControlRenderer.vue';
import { entry as stripeCardRendererEntry } from './StripeCardRenderer.vue';
import { entry as templateLabelRendererEntry } from './TemplateLabelRenderer.vue';
import { entry as templateLayoutRendererEntry } from './TemplateLayoutRenderer.vue';
import { entry as templateRendererEntry } from './TemplateRenderer.vue';
import { entry as slotRendererEntry } from './SlotRenderer.vue';
import { entry as agGridRendererEntry } from './AgGridRenderer.vue';
import { entry as arrayItemEntry } from './ArrayItem.vue';
import { entry as signaturePadRendererEntry } from './SignaturePadRenderer.vue';
import { entry as monacoRendererEntry } from './MonacoRenderer.vue';

import { extendedVuetifyRenderers } from '@jsonforms/vue2-vuetify';

export const commonRenderers = [
  arrayItemEntry,
  agGridRendererEntry,
  buttonRendererEntry,
  templateLabelRendererEntry,
  templateLayoutRendererEntry,
  templateRendererEntry,
  slotRendererEntry,
  fileRendererEntry,
  dataProviderRendererEntry,
  dataProviderSelectRendererEntry,
  addressRendererEntry,
  stripeCardRendererEntry,
  oneOfImageGroupControlRendererEntry,
  signaturePadRendererEntry,
  monacoRendererEntry,
  ...extendedVuetifyRenderers,
];
